module.exports = __webpack_public_path__ + "img/games-dashboard-monster.8fef7f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/games-dashboard-monster.png
// module id = BjYl
// module chunks = 38 43